<template>
  <div class="v3-widget v3-panel" v-testid="testid">
    <div class="v3-panel-head">
      <h3 v-testid="testid + '-title'">{{ title }}</h3>
      <span v-if="rd.count.value" class="v3-count">{{ rd.count.value }}</span>
    </div>

    <V3Skeleton v-if="rd.isLoading.value && !rd.count.value" shape="list" :heading="false" />
    <div v-else-if="!rd.count.value" class="v3-task-empty" v-testid="testid + '-empty'">No recent jobs.</div>

    <div v-else class="v3-list">
      <div
        v-for="r in rd.shownRows.value"
        :key="r.doc_id"
        class="v3-row v3-row--q"
        role="button"
        tabindex="0"
        v-testid="testid + '-row-' + r.doc_id"
        @click="open(r)"
      >
        <div>
          <div class="v3-row-title">{{ rd.title(r) }}</div>
          <div class="v3-row-sub">{{ rd.reference(r) }}</div>
        </div>
        <span class="v3-cell v3-cell--right">{{ rd.whenText(r) }}</span>
        <span v-if="rd.statusLabel(r)" class="v3-spill" :style="{ color: rd.statusColour(r) }">
          <span class="dot"></span>{{ rd.statusLabel(r) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { recentDocs } from "@rm-ui/homepage/recentDocs";
import V3Skeleton from "./cLandingV3Skeleton";

// New-portal (v3) DocList — the "Recent jobs" list (prototype V3DocList) over the
// shared `recentDocs` composable (@rm-ui/homepage/recentDocs, POST
// Report/recentDocs). Sibling: rm-portal-beta DocListWidget.vue.
export default {
  name: "cLandingV3DocList",
  components: { V3Skeleton },
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  setup(props) {
    const rd = recentDocs({
      http: axios,
      getLimit: () => props.definition.limit || 8,
      getDocTypes: () => props.definition.docTypes || [],
    });
    return { rd };
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3DocList";
    },
    title() {
      return this.definition.title || "Recent jobs";
    },
  },
  methods: {
    open(r) {
      if (this.editMode) return;
      const reference = r.reference || r.system_number;
      if (reference) this.$emit("openDocument", { system_number: reference, reference });
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
